module.exports = __webpack_public_path__ + "img/image3.a713142c.jpg";